import AccountNumbers from 'features/myVaro/screens/AccountNumbers/AccountNumbers';
import React from 'react';
import { PinwheelContextProvider } from 'shared/providers/pinwheel/PinwheelContextProvider/PinwheelContextProvider';

export default function AccountNumbersPage() {
  return (
    <PinwheelContextProvider>
      <AccountNumbers />
    </PinwheelContextProvider>
  );
}
